import i18n from "config/i18next";

i18n.addResources("es", "rainBonus", {
  title: "Bonus:",
  subtitle: "Lluvia",
  region: "Región",
  nextRain: "Próximo",
  currentRain: "En curso",
  nextRains: "Próximos",
  previousRains: "Anteriores",
  sort: "Ordenar",
  search: "Buscar",
  add: "Agregar",
  noResults: "No obtuvimos resultados para tu búsqueda :(",
  timeIntervalError: "Solo se admiten intervalos de 15 minutos",
  timeDifferenceError:
    "La diferencia con el comienzo debe ser de al menos 1 hora",
  overlapError: "Ya existe un bonus activo en este horario",
  noNextRain: "--/--/-- --:--",
});
